import Model from 'src/app/common/model';

export default class PersonCategoryModel extends Model {
  name: string;
  code: string;
  description: string;

  constructor() {
    super();
  }
}
